module.exports = __webpack_public_path__ + "static/media/logo-bitbucket.4f9455bc.svg";